@if (activeTenantService.canSwitch()) {
  <div class="relative">
    <button type="button"
            (click)="toggle()"
            class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors hover:bg-white/5"
            style="color:var(--nexus-text);border:1px solid var(--nexus-border)">
      <span class="max-w-[180px] truncate">{{ activeTenantService.active()?.name ?? 'Select company' }}</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-3.5 h-3.5 shrink-0"
           style="color:var(--nexus-text-dim)">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    </button>

    @if (open()) {
      <!-- Backdrop to close on outside click -->
      <div class="fixed inset-0 z-30" (click)="onBackdropClick($event)" (keydown.escape)="close()"></div>

      <!-- Glass popover -->
      <div class="gm-popover absolute left-0 top-full mt-2 z-50">
        <div class="pop-section-label">Switch tenant</div>

        @for (t of activeTenantService.tenants(); track t.id) {
          <div class="ts-row" [class.current]="t.id === activeTenantService.activeId()"
               [class.deleted]="t.deleted_at"
               role="menuitem" tabindex="0"
               (click)="t.deleted_at ? pickDeleted(t.id) : pick(t.id)"
               (keydown.enter)="t.deleted_at ? pickDeleted(t.id) : pick(t.id)"
               (keydown.space)="t.deleted_at ? pickDeleted(t.id) : pick(t.id)"
               [class.nx-opacity-50]="switching() !== null && switching() !== t.id">
            <div class="min-w-0">
              <div class="ts-name truncate">
                {{ t.name }}
                @if (t.id === activeTenantService.activeId()) {
                  <span class="ts-current-chip">(current)</span>
                }
                @if (t.deleted_at) {
                  <span class="ts-deleted-chip">Deleted - restore within {{ daysRemaining(t.deleted_at) }}d</span>
                }
              </div>
              <div class="ts-id truncate">{{ t.id | slice:0:18 }}…</div>
            </div>
            @if (t.id === activeTenantService.activeId()) {
              <span class="nx-dot-cyan shrink-0"></span>
            }
            @if (switching() === t.id) {
              <span class="text-[11px] shrink-0" style="color:var(--nexus-text-dim)">switching…</span>
            }
          </div>
        }

        <div class="pop-sep"></div>
        <a class="menu-item" routerLink="/me/tenants" (click)="close()">
          Manage all tenants →
        </a>
        <a class="menu-item" routerLink="/me/tenants"
             [queryParams]="{ create: true }" (click)="close()"
             style="color:var(--nexus-cyan)">
          + Create new tenant
        </a>
      </div>
    }
  </div>

} @else if (activeTenantService.active(); as t) {
  <span class="text-sm px-2" style="color:var(--nexus-text-dim)">{{ t.name }}</span>
}
